const es = {
  app: { name: 'Veta Desk' },
  common: {
    loading: 'Cargando…',
    cancel: 'Cancelar'
  },
  login: {
    title: 'Entra a Veta Desk',
    subtitle: 'Usa tu mismo correo y contraseña de Veta.',
    email: 'Correo',
    password: 'Contraseña',
    tenant: 'Empresa',
    tenantHelp: 'Tu correo existe en varias empresas. Escribe el identificador de la tuya (el mismo que usas en Veta).',
    submit: 'Entrar',
    submitting: 'Entrando…',
    forgot: '¿Olvidaste tu contraseña? Recupérala en Veta.'
  },
  shell: {
    search: 'Buscar por número o texto',
    newTicket: 'Nuevo ticket',
    settings: 'Configuración',
    mailTriage: 'Correos por clasificar',
    logout: 'Salir',
    views: 'Vistas'
  },
  views: {
    open: 'Todos los abiertos',
    mine: 'Asignados a mí',
    unassigned: 'Sin asignar',
    myGroup: 'Mi grupo',
    atRisk: 'En riesgo de SLA',
    toEstimate: 'Por estimar',
    toQuote: 'Por cotizar',
    awaitingApproval: 'Esperando aprobación del cliente',
    waitingCustomer: 'En espera del cliente',
    waitingThirdParty: 'Esperando a tercero / SAP',
    recentlyResolved: 'Resueltos (por cerrar)'
  },
  inbox: {
    subtitle: 'Ordenados por actualización más reciente',
    subtitleDue: 'Ordenados por lo que vence primero',
    sortLabel: 'Orden',
    sortUpdated: 'Más recientes',
    sortDue: 'Vence primero',
    searchTitle: 'Resultados para «{{q}}»',
    searchSubtitle_one: '{{count}} ticket · incluye cerrados',
    searchSubtitle_other: '{{count}} tickets · incluye cerrados',
    searchEmpty: 'No encontramos tickets con «{{q}}»',
    searchEmptyBody: 'Prueba con el número (p. ej. 15), una palabra del asunto, el cliente o el solicitante.',
    clearSearch: 'Limpiar búsqueda',
    emptyTitle: 'Todavía no hay tickets',
    emptyFiltered: 'No hay tickets en esta vista',
    emptyBody: 'Registra aquí los incidentes, solicitudes y requerimientos de los clientes de {{tenant}}.',
    filterType: 'Filtrar por tipo',
    filterPriority: 'Filtrar por prioridad',
    filterClient: 'Filtrar por cliente',
    allTypes: 'Todos los tipos',
    allPriorities: 'Todas las prioridades',
    allClients: 'Todos los clientes',
    filterGroup: 'Filtrar por grupo',
    allGroups: 'Todos los grupos',
    unassigned: 'Sin asignar',
    col: {
      number: 'Número',
      subject: 'Asunto',
      client: 'Cliente · Iniciativa',
      type: 'Tipo · Prior.',
      status: 'Estado',
      sla: 'SLA',
      assignee: 'Agente',
      updated: 'Actualizado'
    }
  },
  newTicket: {
    title: 'Nuevo ticket',
    subtitle: 'Registra lo que reportó el cliente por correo o teléfono. El número se asigna al guardar.',
    type: 'Tipo de ticket',
    client: 'Cliente',
    chooseClient: 'Elige el cliente…',
    initiative: 'Iniciativa en Veta',
    chooseClientFirst: 'Primero elige el cliente',
    noInitiative: 'Sin iniciativa por ahora',
    initiativeHelp: 'El contrato o proyecto de Veta contra el que se capturarán las horas.',
    requester: 'Solicitante',
    requesterPlaceholder: 'Nombre de quien reporta',
    requesterEmail: 'Correo del solicitante',
    channel: 'Canal',
    category: 'Categoría',
    noCategory: 'Sin categoría',
    impact: 'Impacto',
    urgency: 'Urgencia',
    priority: 'Prioridad',
    subject: 'Asunto',
    description: 'Descripción',
    descriptionPlaceholder: 'Qué pasa, desde cuándo, a quién afecta y qué se ha intentado.',
    group: 'Grupo de resolución',
    noGroup: 'Sin grupo',
    assignee: 'Asignar a',
    leaveUnassigned: 'Dejar sin asignar',
    assignToMe: 'Asignarme',
    create: 'Crear {{type}}',
    creating: 'Creando…'
  },
  errors: {
    generic: 'Algo salió mal. Inténtalo de nuevo.',
    network: 'No hay conexión con el servidor.'
  }
};

export default es;
